import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import BasicBackground from './BasicBackground';
import PrimaryButton from './PrimaryButton';
import { globalStyles } from './style/gstheme';

const styles = theme => {
  return Object.assign({
    notFound: {
      position: 'fixed',
      top: 120,
      right: 0,
      bottom: 0,
      left: 0,
      backgroundColor: theme.palette.primary.main,
      paddingTop: '150px',
      textAlign: 'center'
    }
  }, globalStyles)
};

class NotFound extends Component {

  constructor(props) {
    super(props);
    this.state = {
      readyToReturn: false
    };
  }

  setReady = () => this.setState({ readyToReturn: true });

  render() {

    const { classes } = this.props;

    if (this.state.readyToReturn) return <Redirect to="/" />

    return (
      <BasicBackground>
        <div data-test="not-found" className={classes.notFound}>
          <img src="/images/404.svg" alt="Not found" />
          <Typography className={classes.mainHeading} style={{ fontSize: '34px', color: 'white' }}>Oops</Typography>
          <Typography paragraph variant="body2" style={{ color: 'white', marginBottom: '30px' }}>You managed to get somewhere that doesn't exist.</Typography>
          <PrimaryButton onClick={this.setReady}>Return to the application</PrimaryButton>
        </div>
      </BasicBackground>
    );
  }
}


NotFound.propTypes = {
  classes: PropTypes.object
};

export default withStyles(styles)(NotFound);